import React, { Component } from 'react';
import { trackEvent } from 'react-with-analytics';

import '../../css/views/Agence.css';
import ZigZag from '../../components/ZigZag';
import ZigZagBlanc from '../../components/ZigZagBlanc';
import BlocCta from '../../components/BlocCta';
import FormulaireDeDevis from '../../components/FormulaireDeDevis'
import FormulaireDeRecrutement from '../../components/FormulaireDeRecrutement'

import imageGradient2 from '../../images/gradient-2.jpg';

import imageTriangleBas from '../../images/triangle-bas.png';
import imageElipsePoles from '../../images/elipse-poles.png';

import imagePoleConseilTransformationNumerique from '../../images/pole-conseil-transformation-numerique.png';
import imagePoleConseilElaborationCahierDesCharges from '../../images/pole-conseil-elaboration-cahier-des-charges.png';
import imagePoleConseilBusiness from '../../images/pole-conseil-business.png';
import imagePoleConseilFormation from '../../images/pole-conseil-formation.png';

import imagePoleIdentiteVisuelleConcepts from '../../images/pole-identite-visuelle-concepts.png';
import imagePoleIdentiteVisuelleCharteGraphique from '../../images/pole-identite-visuelle-charte-graphique.png';
import imagePoleIdentiteVisuelleUiUxDesign from '../../images/pole-identite-visuelle-ui-ux-design.png';
import imagePoleIdentiteVisuelleParcours from '../../images/pole-identite-visuelle-parcours.png';

import imagePoleTechnologiqueSolutionsWeb from '../../images/pole-technologique-solutions-web.png';
import imagePoleTechnologiqueSolutionsMobiles from '../../images/pole-technologique-solutions-mobiles.png';
import imagePoleTechnologiqueSolutionsMetier from '../../images/pole-technologique-solutions-metier.png';
import imagePoleTechnologiqueSolutionsPhygital from '../../images/pole-technologique-phygital.png';

import imageTechnologiesInnovantes from '../../images/technologies-innovantes.png';

import imageMethode from '../../images/agence-notre-methode.jpg';
import imageValeurAjoutee from '../../images/agence-notre-valeur-ajoutee.jpg';

import imageTeamNew from '../../images/team-new.jpg';
import imageTeamJNain from '../../images/team-jnain.jpg';
import imageTeamDRaluy from '../../images/team-draluy.jpg';
import imageTeamLorenzo from '../../images/team-larcaini.jpg';
import imageTeamPCressant from '../../images/team-pcressant.jpg';
import imageTeamFCangrand from '../../images/team-fcangrand.jpg';
import imageTeamAKian from '../../images/team-aki.jpg';
import imageTeamSGrimal from '../../images/team-sgr.jpg';
import imageTeamJPivoteau from '../../images/team-jpivoteau.jpg';

import imageTeamNousRecrutons from '../../images/nous-recrutons.jpg';


class Agence extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showForm: false,
            showRecrutement: false
        };

        this.doShowForm = this.doShowForm.bind(this);
        this.doHideForm = this.doHideForm.bind(this);
        this.doShowFormRecrutement = this.doShowFormRecrutement.bind(this);
        this.doHideFormRecrutement = this.doHideFormRecrutement.bind(this);
    }

    doShowForm() {
        trackEvent('Interactions', 'Ouverture de formulaire', 'Devis Agence');
        this.setState( { showForm: true, showRecrutement: false } );
    }

    doHideForm() {
        this.setState( { showForm: false, showRecrutement: false } );
    }

    doShowFormRecrutement() {
        trackEvent('Interactions', 'Ouverture de formulaire', 'Recrutement Agence');
        this.setState( { showForm: false, showRecrutement: true } );
    }

    doHideFormRecrutement() {
        this.setState( { showForm: false, showRecrutement: false } );
    }

  render() {
    return (
    <div className="agence inner-content-page">
        <section className="hero-unit">
            <div>
                <img src={imageGradient2} alt="" />
                <div>Concepteurs<br />de solutions intelligentes</div>
            </div>
            <div>
                <p>
                    ARCA est une <strong>agence de conseil et développement logiciel</strong>, fondée en 2010 par Lorenzo ARCAINI, développeur de métier.
                </p>
                <p>
                    Sa vision ? Accompagner les entreprises innovantes, les TPE, PME et ETI dans leur <strong>transformation numérique</strong>.
                </p>
            </div>
        </section>

        <section className="page-content">
            <section className="bloc-texte">
                <ZigZag />
                <h2>Nos expertises</h2>
                <ZigZag />
                <p>
                    La transformation numérique est un défi pour les entreprises. ARCA Computing l'a bien compris et a souhaité transformer son "studio de développement" en véritable <strong>agence de conseil et de développement logiciel</strong>.
                </p>
                <p>
                    Pour cela, elle s'est entourée d'une équipe d'experts, organisés autour de 3 pôles stratégiques :
                </p>
                <p>
                    <strong>le conseil, le développement logiciel, l'identité visuelle</strong>.
                </p>
                <h3>Un accompagnement et un suivi personnalisé, dans le respect de vos enjeux stratégiques.</h3>
            </section>
        </section>

        <section className="pole pole-conseil">
            <div className="signaletique">
                <img alt="" src={imageTriangleBas} />
                <img alt="" src={imageTriangleBas} />
            </div>
            <h2>pôle conseil</h2>
            <div className="pole-section">
                <div className="figure">
                    <img src={imageElipsePoles} alt="" />
                    <img src={imagePoleConseilTransformationNumerique} alt="Transformation numérique" />
                    <p>Transformation numérique</p>
                </div>
                <ZigZagBlanc />
                <div className="figure">
                    <img src={imageElipsePoles} alt="" />
                    <img src={imagePoleConseilElaborationCahierDesCharges} alt="Elaboration cahier des charges" />
                    <p>Elaboration<br />cahier des charges</p>
                </div>
                <ZigZagBlanc />
            </div>
            <div className="pole-section">
                <ZigZagBlanc />
                <div className="figure">
                    <img src={imageElipsePoles} alt="" />
                    <img src={imagePoleConseilBusiness} alt="Business commerce connecté" />
                    <p>Business commerce connecté</p>
                </div>
                <ZigZagBlanc />
                <div className="figure">
                    <img src={imageElipsePoles} alt="" />
                    <img src={imagePoleConseilFormation} alt="Formation" />
                    <p>Formation</p>
                </div>
            </div>
        </section>

        <section className="pole pole-identite-visuelle">
            <div className="signaletique">
                <img alt="" src={imageTriangleBas} />
                <img alt="" src={imageTriangleBas} />
            </div>
            <h2>pôle identité visuelle</h2>
            <div className="pole-section">
                <div className="figure">
                    <img src={imageElipsePoles} alt="" />
                    <img src={imagePoleIdentiteVisuelleConcepts} alt="" />
                    <p>Concepts et idées créatives</p>
                </div>
                <ZigZagBlanc />
                <div className="figure">
                    <img src={imageElipsePoles} alt="" />
                    <img src={imagePoleIdentiteVisuelleCharteGraphique} alt="" />
                    <p>Charte graphique</p>
                </div>
                <ZigZagBlanc />
            </div>
            <div className="pole-section">
                <ZigZagBlanc />
                <div className="figure">
                    <img src={imageElipsePoles} alt="" />
                    <img src={imagePoleIdentiteVisuelleUiUxDesign} alt="" />
                    <p>UI/UX design</p>
                </div>
                <ZigZagBlanc />
                <div className="figure">
                    <img src={imageElipsePoles} alt="" />
                    <img src={imagePoleIdentiteVisuelleParcours} alt="" />
                    <p>Parcours et expérience utilisateurs</p>
                </div>
            </div>
        </section>

        <section className="pole pole-technologique">
            <div className="signaletique">
                <img alt="" src={imageTriangleBas} />
                <img alt="" src={imageTriangleBas} />
            </div>
            <h2>pôle technologique</h2>
            <div className="pole-section">
                <div className="figure">
                    <img src={imageElipsePoles} alt="" />
                    <img src={imagePoleTechnologiqueSolutionsWeb} alt="" />
                    <p>Solutions web</p>
                </div>
                <ZigZagBlanc />
                <div className="figure">
                    <img src={imageElipsePoles} alt="" />
                    <img src={imagePoleTechnologiqueSolutionsMobiles} alt="" />
                    <p>Solutions mobiles</p>
                </div>
                <ZigZagBlanc />
            </div>
            <div className="pole-section">
                <ZigZagBlanc />
                <div className="figure">
                    <img src={imageElipsePoles} alt="" />
                    <img src={imagePoleTechnologiqueSolutionsMetier} alt="" />
                    <p>Solutions métiers</p>
                </div>
                <ZigZagBlanc />
                <div className="figure">
                    <img src={imageElipsePoles} alt="" />
                    <img src={imagePoleTechnologiqueSolutionsPhygital} alt="" />
                    <p>Solutions phygitales Commerce connecté</p>
                </div>
            </div>
        </section>

        <section className="page-content">
            <section className="bloc-texte technologies-innovantes">
                <ZigZag />
                <h2>Technologies innovantes maîtrisées</h2>
                <ZigZag />
                <p>
                    Une maîtrise de technologies complémentaires pour des développements pertinents et des applications inédites.
                </p>
                <img src={imageTechnologiesInnovantes} alt="Technologies Innovantes : mobile, iot, blockchain, ia, big data, cloud" />
            </section>

            <section className="bloc-duo valeur-ajoutee-methode">
                <BlocCta
                    image={ {"src": imageValeurAjoutee, "alt": "valeur ajoutée"} }
                    title={ "notre valeur ajoutée" }
                    subtitle={ "Une prise en charge numérique globale...<br /><br />Dans un contexte où la <em>transformation digitale</em> remet en question le modèle économique des entreprises, nous vous aidons à maximiser vos performances grâce à des <em>solutions digitales intelligentes</em>." }
                    link={ {"onClick": this.doShowForm, "label": "Contactez-nous !"} }
                 />
                <BlocCta
                    image={ {"src": imageMethode, "alt": "methode"} }
                    title={ "notre méthode" }
                    subtitle={ "Vous avez l'impression que la transformation numérique est un sujet inaccessible ? Trop technique ?<br /><br />A l'écoute de votre demande et de vos besoins, nous construisons avec vous la <em>feuille de route</em> qui sera la plus en phase avec vos objectifs, vos attentes et votre culture d'entreprise, afin d'élaborer <em>la solution digitale</em> la plus adaptée.<br /><br />Cette méthode est agile et <em>créatrice de valeur ajoutée</em>." }
                    link={ {"href": "/methode", "label": "Découvrir la méthode ARCA"} }
                 />
            </section>

            <div id="equipe"/>

            <section className="bloc-texte">
                <ZigZag />
                <h2>La team ARCA,<br />des experts pour vous faire avancer dans vos projets</h2>
                <ZigZag />
            </section>

            <section className="bloc-texte">
                <h2>Agence de Bordeaux</h2>

                <section className="bloc-team">
                    <section className="bloc-team-pictures">
                        <BlocCta
                            extraClassName={ "est-petit" }
                            extraImgClassName={"gradient-orange-bleu trame"}
                            image={ {"src": imageTeamLorenzo, "alt": "Lorenzo"} }
                            title={ "Lorenzo" }
                            subtitle={ "Directeur" }
                        />
                        <BlocCta
                            extraClassName={ "est-petit" }
                            extraImgClassName={"gradient-rose-bleu trame"}
                            image={ {"src": imageTeamDRaluy, "alt": "David"} }
                            title={ "David" }
                            subtitle={ "CTO" }
                        />
                        <BlocCta
                            extraClassName={ "est-petit" }
                            extraImgClassName={"gradient-rose-bleu trame"}
                            image={ {"src": imageTeamJNain, "alt": "Jonathan"} }
                            title={ "Jonathan" }
                            subtitle={ "Développeur" }
                        />
                        <BlocCta
                            extraClassName={ "est-petit" }
                            extraImgClassName={"gradient-orange-bleu trame"}
                            image={ {"src": imageTeamPCressant, "alt": "Pierre"} }
                            title={ "Pierre" }
                            subtitle={ "Développeur" }
                        />
                        <BlocCta
                            extraClassName={ "est-petit" }
                            extraImgClassName={"gradient-orange-bleu trame"}
                            image={ {"src": imageTeamFCangrand, "alt": "Florian"} }
                            title={ "Florian" }
                            subtitle={ "Développeur" }
                        />
                        <BlocCta
                            extraClassName={ "est-petit" }
                            extraImgClassName={"gradient-orange-bleu trame"}
                            image={ {"src": imageTeamAKian, "alt": "Arash"} }
                            title={ "Arash" }
                            subtitle={ "Développeur" }
                        />
                        <BlocCta
                            extraClassName={ "est-petit" }
                            extraImgClassName={"gradient-orange-bleu trame"}
                            image={ {"src": imageTeamSGrimal, "alt": "Stéphane"} }
                            title={ "Stéphane" }
                            subtitle={ "Développeur" }
                        />
                        <BlocCta
                            extraClassName={ "est-petit" }
                            extraImgClassName={"gradient-orange-bleu trame"}
                            image={ {"src": imageTeamJPivoteau, "alt": "Judith"} }
                            title={ "Judith" }
                            subtitle={ "Développeuse" }
                        />
                    </section>
                </section>

                <h2>Agence de Lyon</h2>

                <section className="bloc-team">
                    <section className="bloc-team-pictures">
                        <BlocCta
                            extraClassName={ "est-petit" }
                            extraImgClassName={"gradient-orange-bleu trame"}
                            image={ {"src": imageTeamNew, "alt": "Sanae"} }
                            title={ "Sanae" }
                            subtitle={ "Développeuse" }
                        />
                        <BlocCta
                            extraClassName={ "est-petit" }
                            extraImgClassName={"gradient-rose-bleu trame"}
                            image={ {"src": imageTeamNew, "alt": "Alexis"} }
                            title={ "Alexis" }
                            subtitle={ "Développeur" }
                        />
                    </section>
                </section>
            </section>

            <section className="bloc-texte">
                <BlocCta
                    extraClassName={ "shrink recruiting" }
                    extraImgClassName={"gradient-rose-bleu"}
                    image={ {"src": imageTeamNousRecrutons, "alt": "nous recrutons !"} }
                    title={ "Nous recrutons !" }
                    subtitle={ "Nous sommes sans cesse en recherche de nouveaux profils pour faire grandir nos équipes. N'hésitez pas à nous faire parvenir votre candidature." }
                    link={ {"onClick": this.doShowFormRecrutement, "label": "Rejoignez notre équipe !"} }
                />
            </section>

        </section>
        <FormulaireDeDevis show={this.state.showForm} onCancel={this.doHideForm} />
        <FormulaireDeRecrutement show={this.state.showRecrutement} onCancel={this.doHideFormRecrutement} />
    </div>
    );
  }
}

export default Agence;



// WEBPACK FOOTER //
// ./src/views/agence/Agence.js